export const VERSION = Object.keys({
  __packageVersion__: "xxxx",
})[0] as string;
